import { Select } from "antd";

interface PageSizeSelectProps {
    options: number[];
    value: number;
    onChange: (value: number) => void;
    pageLabel: string;
}

export function PageSizeSelect({
    options = [],
    value,
    onChange,
    pageLabel,
}: PageSizeSelectProps) {
    return (
        <Select
            value={value}
            onChange={onChange}
            options={options.map((option) => ({
                value: option,
                label: `${option.toString()} / ${pageLabel}`,
            }))}
        />
    );
}
